import React from 'react';
import { Modal, Typography, Button } from 'antd';
import ButtonRow from 'components/common/ButtonRow';
import { Industry } from 'types/Industry';

type IndustryActivationModalProps = {
  industry: Industry;
  action: string;
  isModalVisible: boolean;
  onSubmit: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  closeModal: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const IndustryActivationModal = (props: IndustryActivationModalProps) => {
  return (
    <Modal
      title={props.action + ' Industry'}
      visible={props.isModalVisible}
      onCancel={props.closeModal}
      footer={null}
    >
      <Typography.Paragraph strong>
        Are you sure you want to {props.action.toLowerCase()} this industry?
      </Typography.Paragraph>
      <Typography.Paragraph>{props.industry.name}</Typography.Paragraph>
      <ButtonRow style={{ marginTop: '2em' }}>
        <Button type="primary" onClick={props.onSubmit}>
          {props.action}
        </Button>
        <Button onClick={props.closeModal}>Cancel</Button>
      </ButtonRow>
    </Modal>
  );
};

export default IndustryActivationModal;